/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
var n = /* @__PURE__ */ ((r) => (r[r.Literal = 0] = "Literal", r[r.Mask = 1] = "Mask", r[r.Undefined = 2] = "Undefined", r))(n || {});
class s {
  constructor(t, e, i = 2) {
    this.value = t, this.rest = e, this.type = i;
  }
  // map :: Functor f => f a ~> (a -> b) -> f b
  map(t) {
    return new s(t(this.value), this.rest);
  }
  // chain :: Chain m => m a ~> (a -> m b) -> m b
  chain(t) {
    return t(this.value, this.rest);
  }
  fold(t, e) {
    return t(this.value, this.rest);
  }
  concat(t) {
    return this.map((e, i) => t.chain((a, h) => e.concat([a])));
  }
  toString() {
    return `Result({ value: '${this.value}', rest: ${this.rest} })`;
  }
}
export {
  s as Result,
  n as ResultType
};
